import {
  fetchPrimaryCareData,
  PrimaryCareApiResponse,
  searchPrimaryCareData,
} from "../../../api/bigQuery/pharmaPrimaryCareOrders";
import { AestraPrimaryCareTable } from "../../../data-model/aestraPrimaryCareTable";
import { OrganizationType } from "../../../enums/organizationTypes";
import { logError } from "../../../utils/customLogger";
import { PrimaryCareFilterPayload } from "../hooks/useFilterPayload";
import { PrimaryCareTableState } from "../hooks/usePrimaryCareTableData";

export const makePostCallForNextPagesDataFetch = async (
  signal: AbortSignal,
  payload: PrimaryCareFilterPayload,
  setPrimaryCareState: React.Dispatch<
    React.SetStateAction<PrimaryCareTableState>
  >,
  setTableData: React.Dispatch<React.SetStateAction<AestraPrimaryCareTable[]>>,
): Promise<void> => {
  try {
    setPrimaryCareState((prev) => ({
      ...prev,
      showInlineLoader: true,
      error: null,
    }));

    // const selectedOrganization =
    //   getItemFromLocalStorage(LocalStorageKeys.HEALTHCARE_FACILITY_ID) ?? "";
    const selectedOrganization = OrganizationType.ASTERA_PRIMARY_CARE;

    const response: PrimaryCareApiResponse = payload.keyword
      ? await searchPrimaryCareData(
          {
            ...payload,
            org_id: selectedOrganization,
          },
          signal,
        )
      : await fetchPrimaryCareData(
          {
            ...payload,
            org_id: selectedOrganization,
          },
          signal,
        );

    if (response.details?.rows) {
      setPrimaryCareState({
        data: response,
        loading: false,
        error: null,
        showInlineLoader: false,
      });

      // Append new data to existing data
      setTableData((prevData) => [...prevData, ...response.details.rows]);
    } else {
      setPrimaryCareState((prev) => ({
        ...prev,
        showInlineLoader: false,
        error: response.message || "Failed to fetch next page",
      }));
    }
  } catch (error) {
    const errorMessage =
      error instanceof Error ? error.message : "An unknown error occurred";
    setPrimaryCareState((prev) => ({
      ...prev,
      showInlineLoader: false,
      error: errorMessage,
    }));
    logError(error as Error, "Error in makePostCallForNextPagesDataFetch");
  }
};
